/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-twitter-widgets/~/lodash/_freeGlobal.js
 ** module id = 144
 ** module chunks = 0
 **/